export default __webpack_public_path__ + "static/media/accenture-fs-2021-400x400 (1).7f26ee9f.webp";